import { useStateParams } from './use-state-params';

export function useSearchWithSearchParams() {
  return useStateParams<string>('', 'query', value => value, value => value);
}